import type en from './locales/en.json'

type DottedKeys<T> = {
  [K in keyof T & string]: T[K] extends string ? K : `${K}.${DottedKeys<T[K]>}`
}[keyof T & string]

/** Every key in the English catalog. Services and composables return these, never localized text. */
export type MessageKey = DottedKeys<typeof en>

export type MessageParams = Readonly<Record<string, string | number>>

/** A serializable message: a catalog key plus params. Translated at the component boundary. */
export interface MessageRef {
  readonly key: MessageKey
  readonly params?: MessageParams
}

export function messageRef(key: MessageKey, params?: MessageParams): MessageRef {
  return params ? { key, params } : { key }
}
